import { render } from "./ParameterDashboard.vue?vue&type=template&id=5a7341f2"
import script from "./ParameterDashboard.vue?vue&type=script&lang=js"
export * from "./ParameterDashboard.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__